/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { Insights } from '@components/portfolio/insights';
import { Route, Switch, useParams } from 'react-router-dom';
import { portfolioTrackerRoutes } from '.';
import { PortfolioCustomDashboardRoute } from './insight-dashboards/PortfolioCustomDashboardRoute';

export const PortfolioInsightRoute = () => {
  const { dashboardId } = useParams<{ dashboardId?: string }>();

  return (
    <Switch>
      <Route path={portfolioTrackerRoutes.PORTFOLIO_TRACKER_INSIGHT_DASHBOARDS.path}>
        <PortfolioCustomDashboardRoute key={dashboardId} />
      </Route>

      <Route>
        <Insights />
      </Route>
    </Switch>
  );
};
